module.exports = __webpack_public_path__ + "img/Telegram.73ffd62.svg";